import React from 'react';
import SiteHeader from '../Views/SiteHeader';
import ContactFooter from '../Components/ContactFooter';
import './Photo.css';

const Photo = () => {
  return (
    <div className="photo-container">
      <SiteHeader />
      <main className="photo-main">
        <h1 className="photo-title">Photo</h1>
        <hr className="photo-rule" />
        <p>This is the Photo page.</p>
      </main>
      <ContactFooter />
    </div>
  );
};

export default Photo;
